'use client';

import { handle_GTM_33 } from '@gtm/33';
import { handle_GTM_34 } from '@gtm/34';
import { handle_GTM_52 } from '@gtm/52';
import { handle_GTM_64 } from '@gtm/64';
import { handle_GTM_69 } from '@gtm/69';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { useIntersectionObservers } from 'eco-design-micro/hooks/useIntersectionObservers';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import Arrow from '../../product-series/content/icons';
import { ItfProductSwiperData, ItfProductSwiperItem, ItfProductSwiperItemBtn } from '../setting/type';
import './index.scss';
import { Swiper as SwiperType } from 'swiper/types';

interface ItfAniArrItem {
    name: string;
    cls: string;
}

export default function Content({ id, data = {}, isEditStatus }: ContentServerProps) {
    const { items = [] as ItfProductSwiperItem[], theme, title, titleColor } = data as ItfProductSwiperData;
    const prefixCls = 'product-swiper';
    const [type, setType] = useState<'narrow' | 'wide' | ''>('wide'); // narrow: 4个及以上，wide: 5个以下
    const [h, setH] = useState<number>(0);
    const swiperRef = useRef<any>(null);
    const [swiper, setSwiper] = useState<SwiperType | null>(null);

    const [enter, setEnter] = useState({
        title: isEditStatus,
        content: isEditStatus,
    });

    const arr: ItfAniArrItem[] = [
        { name: 'title', cls: `${prefixCls}-info-title` },
        { name: 'content', cls: `${prefixCls}-swiper-box` },
    ];

    const handle_GTM_Event = (btn: ItfProductSwiperItemBtn, name: string) => {
        const { url, text } = btn;
        // 1. checkout => https://us.ecoflow.com/checkouts/cn/hWN6bOi6WvZ1r1ECVcafOoKO/en-us?_r=AQABFnGHZn-cZ1lZW7AM6Pa19wIXIWn4XUcLF8yGzrkL
        const regex1 = /^https:\/\/[a-z]{2}\.ecoflow\.com\/(?:cart|checkouts)\//i;
        const regex2 = /^https:\/\/[a-z]{2}\.ecoflow\.com\//i;
        const regex3 = /^(https:\/\/)?www\.ecoflow\.com\/[a-z]{2}\//i;
        if (regex1.test(url)) {
            // 1. checkout shopify结账页
            handle_GTM_34({
                button_name: `${text}_${name}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex2.test(url)) {
            // 2. shopify 其他页
            handle_GTM_33({
                product_name: name,
                position: `Series_ProductSwiper_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex3.test(url)) {
            // 3. 官网网页
            handle_GTM_52({
                list_name: title,
                product_name: name,
                button_name: text,
                position: `Series_ProductSwiper_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else {
            // 4. 其他
            handle_GTM_64({
                list_name: title,
                button_name: text,
                position: `Series_ProductSwiper_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        }
    };

    const handleGTM = (btn: string) => {
        handle_GTM_69({
            button_name: btn,
            position: `Series_ProductSwiper-${id}`,
            __btn_id1: `editor-${prefixCls}-${id}`,
            __btn_id2: btn,
            __btn_type: 'common',
        });
    };

    useIntersectionObservers(
        {
            selectors: [`.editor-${prefixCls}-${id} .${prefixCls}-info-title`, `.editor-${prefixCls}-${id} .${prefixCls}-swiper-box`],
            onEnter: (e: Element) => {
                const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
                if (aim) {
                    setEnter((prev) => ({ ...prev, [aim.name]: true }));
                }
            },
            // onLeave: (e: Element) => {
            //     const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
            //     if (aim) {
            //         setEnter((prev) => ({ ...prev, [aim.name]: false }));
            //     }
            // },
        },
        [],
        isEditStatus,
    );

    useEffect(() => {
        setType(items?.length >= 4 ? 'narrow' : items?.length >= 1 ? 'wide' : '');
    }, [items]);

    useLayoutEffect(() => {
        setTimeout(() => {
            if (!h && items?.length > 0) {
                const doms = document.querySelectorAll(
                    `.editor-${prefixCls}-${id} .${prefixCls}-swiper-item .${prefixCls}-swiper-item-content`,
                ) as NodeListOf<HTMLDivElement>;
                let h = 0;
                if (doms?.length > 0) {
                    for (let i = 0; i < doms?.length; i++) {
                        if (doms?.[i]) {
                            if (doms[i]?.offsetHeight > h) {
                                h = doms[i]?.offsetHeight;
                            }
                        }
                    }
                }
                setH(h);
            }
        }, 3000);
    }, [items, h]);

    useEffect(() => {
        if (swiperRef.current && swiper) {
            const prev = swiperRef.current.querySelector('.swiper-button-prev');
            const next = swiperRef.current.querySelector('.swiper-button-next');
            if (prev) {
                prev.classList.add('GtmModuleData-btn-common');
                prev.setAttribute('data-btn-id', '<');
                prev.addEventListener('click', () => handleGTM('<'));
            }
            if (next) {
                next.classList.add('GtmModuleData-btn-common');
                next.setAttribute('data-btn-id', '>');
                next.addEventListener('click', () => handleGTM('>'));
            }
            return () => {
                if (prev) {
                    prev.removeEventListener('click', () => handleGTM('<'));
                }
                if (next) {
                    next.removeEventListener('click', () => handleGTM('>'));
                }
            };
        }
    }, [swiperRef.current, swiper]);

    return (
        <GloLayout className={`editor-${prefixCls} editor-${prefixCls}-${id} theme-${theme} type-${type}`} id={id} data={data} floorName={prefixCls}>
            <div className={`${prefixCls}-info`}>
                {title && (
                    <div className={`${prefixCls}-info-title ${enter?.title ? 'enter' : ''}`} style={{ color: titleColor }} title={title}>
                        {title}
                    </div>
                )}
            </div>
            <div className={`${prefixCls}-swiper-box`} ref={swiperRef}>
                <Swiper
                    key={type}
                    className={`${prefixCls}-swiper`}
                    initialSlide={0}
                    spaceBetween={12}
                    slidesPerView={'auto'}
                    modules={[Navigation]}
                    navigation={items?.length > 1}
                    onSwiper={(swiperIns: SwiperType) => setSwiper(swiperIns)}
                >
                    {items?.map((item: ItfProductSwiperItem, i: number) => {
                        const { label, labelColor, name, nameColor, text, textColor, pc, h5, btns } = item;
                        const itemClasses = classNames({
                            [`${prefixCls}-swiper-item`]: true,
                            [`${prefixCls}-swiper-item-${i}`]: true,
                            [`${prefixCls}-swiper-item-type-${type}`]: true,
                            ['enter']: enter?.content,
                        });
                        const hasBtn = btns.some((btn: ItfProductSwiperItemBtn) => btn.url && btn.text);
                        return (
                            <SwiperSlide className={itemClasses} key={`${i}`} style={{ transitionDelay: enter?.content ? `${(i + 1) * 0.15}s` : '0s' }}>
                                <div className={`${prefixCls}-swiper-item-inner`}>
                                    <div className={`${prefixCls}-swiper-item-img`}>
                                        <EcoImg pc={pc} h5={h5} />
                                    </div>
                                    <div className={`${prefixCls}-swiper-item-content`} style={h ? { height: `${h}px` } : {}}>
                                        {label && (
                                            <div className={`${prefixCls}-swiper-item-content-label`} style={{ color: labelColor || '' }}>
                                                {label}
                                            </div>
                                        )}
                                        {name && (
                                            <div className={`${prefixCls}-swiper-item-content-name`} style={{ color: nameColor || '' }} title={name}>
                                                {name}
                                            </div>
                                        )}
                                        {text && (
                                            <div className={`${prefixCls}-swiper-item-content-text`} style={{ color: textColor || '' }} title={text}>
                                                {text}
                                            </div>
                                        )}
                                        {hasBtn && (
                                            <div className={`${prefixCls}-swiper-item-content-btns`}>
                                                {btns?.map((btn: ItfProductSwiperItemBtn, j: number) => {
                                                    const { type, url, text } = btn;
                                                    return (
                                                        url &&
                                                        text && (
                                                            <EcoLink
                                                                className={`${prefixCls}-swiper-item-content-btns-btn GtmModuleData-btn-href type-${type} theme-${theme}`}
                                                                href={url}
                                                                onClick={() => handle_GTM_Event(btn, name)}
                                                                key={`${i}-${j}`}
                                                                style={
                                                                    ['fill'].includes(btn?.type)
                                                                        ? {
                                                                              color: btn?.color,
                                                                              background: btn?.bgColor,
                                                                              borderColor: btn?.bgColor,
                                                                          }
                                                                        : ['outline'].includes(btn?.type)
                                                                        ? { color: btn?.color, borderColor: btn?.color }
                                                                        : { color: btn?.color }
                                                                }
                                                            >
                                                                <span>{text}</span>
                                                                {type === 'text' && <Arrow />}
                                                            </EcoLink>
                                                        )
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </GloLayout>
    );
}
